import ChoosingUs from './ChoosingUs';
export default ChoosingUs;